// Ensure all pages are prerendered at build time
export const prerender = true;
